import React from 'react';
import { Box, Typography } from '@mui/material';
import { Autorenew } from '@mui/icons-material';

interface ReusePlaceholderProps {
  variant?: 'thumbnail' | 'detail';
}

export const ReusePlaceholder: React.FC<ReusePlaceholderProps> = ({
  variant = 'thumbnail',
}) => {
  const isDetail = variant === 'detail';

  return (
    <Box
      data-testid="reuse-placeholder"
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'success.50',
        borderRadius: 1,
        gap: isDetail ? 1.5 : 0.5,
      }}
    >
      <Autorenew
        sx={{
          fontSize: isDetail ? 48 : 24,
          color: 'success.main',
        }}
      />
      {isDetail && (
        <Typography
          variant="body2"
          sx={{ color: 'success.main', fontWeight: 500 }}
        >
          Available for Reuse
        </Typography>
      )}
    </Box>
  );
};
